import React from 'react'
import { connect } from 'react-redux'
import GuestRegistryHeader from './guest-registry-header'
import {
  getArrivalDate,
  getRegistryDescription,
  getRegistryPhoto,
  getRegistryTitle,
} from '../../reducers'

const mapStateToProps = (state) => ({
  arrivalDate: getArrivalDate(state),
  note: getRegistryDescription(state),
  photoUrl: getRegistryPhoto(state),
  title: getRegistryTitle(state),
})

export default connect(mapStateToProps)(GuestRegistryHeader)
